import { createAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { 
    ASYNC_NOMENCLATURE_LIST, 
    START_NOMENCLATURE_LIST, 
    STOP_NOMENCLATURE_LIST, 
    NomenclatureItem, 
    FILL_NOMENCLATURE_LIST, 
    ERROR_NOMENCLATURE_LIST,
    ASYNC_NOMENCLATURE_CHANGE,
    ERROR_NOMENCLATURE_CHANGE,
    FILL_NOMENCLATURE_CHANGE,
    START_NOMENCLATURE_CHANGE,
    STOP_NOMENCLATURE_CHANGE,
    ASYNC_NOMENCLATURE_DETAIL,
    ERROR_NOMENCLATURE_DETAIL,
    FILL_NOMENCLATURE_DETAIL,
    START_NOMENCLATURE_DETAIL,
    STOP_NOMENCLATURE_DETAIL,
    ASYNC_NOMENCLATURE_DELETE,
    ERROR_NOMENCLATURE_DELETE,
    FILL_NOMENCLATURE_DELETE,
    START_NOMENCLATURE_DELETE,
    STOP_NOMENCLATURE_DELETE,
    ASYNC_NOMENCLATURE_CREATE,
    ERROR_NOMENCLATURE_CREATE,
    FILL_NOMENCLATURE_CREATE,
    START_NOMENCLATURE_CREATE,
    STOP_NOMENCLATURE_CREATE,
    NomenclatureItemCreate,
} from "./types";


export const asyncNomenclatureList = createAction(ASYNC_NOMENCLATURE_LIST);
export const startNomenclatureList = createAction(START_NOMENCLATURE_LIST);
export const stopNomenclatureList = createAction(STOP_NOMENCLATURE_LIST);
export const fillNomenclatureList = createAction<{data: NomenclatureItem[]}>(FILL_NOMENCLATURE_LIST);
export const errorNomenclatureList = createAction<AxiosError>(ERROR_NOMENCLATURE_LIST);


export const asyncNomenclatureDetail = createAction<{id: number | string}>(ASYNC_NOMENCLATURE_DETAIL);
export const startNomenclatureDetail = createAction(START_NOMENCLATURE_DETAIL);
export const stopNomenclatureDetail = createAction(STOP_NOMENCLATURE_DETAIL);
export const fillNomenclatureDetail = createAction<NomenclatureItem>(FILL_NOMENCLATURE_DETAIL);
export const errorNomenclatureDetail = createAction<AxiosError>(ERROR_NOMENCLATURE_DETAIL);


export const asyncNomenclatureChange = createAction<NomenclatureItem>(ASYNC_NOMENCLATURE_CHANGE);
export const startNomenclatureChange = createAction(START_NOMENCLATURE_CHANGE);
export const stopNomenclatureChange = createAction(STOP_NOMENCLATURE_CHANGE);
export const fillNomenclatureChange = createAction(FILL_NOMENCLATURE_CHANGE);
export const errorNomenclatureChange = createAction<AxiosError>(ERROR_NOMENCLATURE_CHANGE);


export const asyncNomenclatureDelete = createAction<{id: number | string}>(ASYNC_NOMENCLATURE_DELETE);
export const startNomenclatureDelete = createAction(START_NOMENCLATURE_DELETE);
export const stopNomenclatureDelete = createAction(STOP_NOMENCLATURE_DELETE);
export const fillNomenclatureDelete = createAction(FILL_NOMENCLATURE_DELETE);
export const errorNomenclatureDelete = createAction<AxiosError>(ERROR_NOMENCLATURE_DELETE);


export const asyncNomenclatureCreate = createAction<NomenclatureItemCreate>(ASYNC_NOMENCLATURE_CREATE);
export const startNomenclatureCreate = createAction(START_NOMENCLATURE_CREATE);
export const stopNomenclatureCreate = createAction(STOP_NOMENCLATURE_CREATE);
export const fillNomenclatureCreate = createAction(FILL_NOMENCLATURE_CREATE);
export const errorNomenclatureCreate = createAction<AxiosError>(ERROR_NOMENCLATURE_CREATE);
